import "./style.scss";
import { Avatar, Button } from "@mui/material";
// import { ReactComponent as Logo } from "assets/icons/logo.svg";
import DropDownWrapper from "../DropDownWrapper";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Link } from "react-router-dom";
import { ReactComponent as LogOutIcon } from "assets/icons/logout.svg";
import PersonIcon from "@mui/icons-material/Person";
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { logoutAdmin } from "store/slice/AuthSlice";
import { useGetUser } from "hooks/getUserHook";
import mobileLogo from "assets/icons/logo.png";

const Navbar = () => {
  const { user } = useGetUser();

  return (
    <div className="pd_navbar">
      <img src={mobileLogo} alt="Paay logo" className="logo" />
      <DropDownWrapper
        action={
          <Button
            startIcon={
              <Avatar
                className="avatar"
                alt={user?.full_name}
                src={user?.profile_image}
              />
            }
            endIcon={<ArrowDropDownIcon />}
            color="textClr"
            sx={{ p: "0.5rem" }}
            className="profile-action"
          >
            <p>Account</p>
          </Button>
        }
        className="profile-drop-down"
      >
        <Button
          component={Link}
          to="/admin/settings"
          color="textLightClr"
          startIcon={<PersonIcon />}
        >
          Account settings
        </Button>
        <div className="hr" />
        <Button onClick={logoutAdmin} color="redClr" startIcon={<LogOutIcon />}>
          Logout
        </Button>
      </DropDownWrapper>
    </div>
  );
};

export default Navbar;
